export default "/images/vendor/@coreui/icons/svg/flag/cif-dj.svg?db011bfc90ed8afdb517136d3817b82e";